import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  key: 1,
  class: "section content-container"
}
const _hoisted_3 = { class: "container is-fluid" }
const _hoisted_4 = { class: "columns" }
const _hoisted_5 = { class: "column" }
const _hoisted_6 = { class: "island" }
const _hoisted_7 = { class: "level" }
const _hoisted_8 = { class: "level-right" }
const _hoisted_9 = { class: "level-item" }
const _hoisted_10 = { class: "no-intents" }
const _hoisted_11 = ["onClick"]

import Toast from '@/shared/services/toast';
import { IntentListItemViewModel } from '../models/intents/intentListItemViewModel';
import AddIntentModal from '@/features/bots/components/designer/AddIntentModal.vue';
import { LOAD_INTENTS } from '@/store/intents/actionTypes';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import EditIntentModal from '@/features/bots/components/designer/EditIntentModal.vue';
import DeleteIntentModal from '@/features/bots/components/designer/DeleteIntentModal.vue';
import DropDownMenu from '@/shared/components/dropDownMenu/DropDownMenu.vue';
import DeleteIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import { useStore } from 'vuex';
import { computed, nextTick, onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Intents',
  setup(__props) {

library.add(faSearch);

const store = useStore();
const intents = computed<IntentListItemViewModel[]>(() => store.getters.intents);

const loadIntents = (forceLoad?: boolean): Promise<void> => store.dispatch(LOAD_INTENTS, forceLoad);

const loading = ref(false);
const intentToEdit = ref<IntentListItemViewModel>();
const intentToDelete = ref<IntentListItemViewModel>();
const addIntentModal = ref<typeof AddIntentModal | null>(null);

const showAddModal = ref(false);
const showEditModal = computed(() => !!intentToEdit.value);
const showDeleteModal = computed(() => !!intentToDelete.value);
const sortedIntents = computed<IntentListItemViewModel[]>(() =>
  intents.value.sort((a: IntentListItemViewModel, b: IntentListItemViewModel) => a.title.localeCompare(b.title)),
);

const tableColumns = [
  {
    display: 'Intent',
    name: 'title',
    clickable: true,
  },
  {
    display: 'Utterances',
    name: 'utteranceCount',
  },
];

onMounted(async () => await getIntents());

async function onEditCompleted(): Promise<void> {
  intentToEdit.value = undefined;
  intentToDelete.value = undefined;
  await getIntents();
}

async function getIntents(): Promise<void> {
  loading.value = true;
  try {
    await loadIntents(true);
  } catch (error: any) {
    Toast.showError(error.message);
  }
  loading.value = false;
}

async function addIntent() {
  showAddModal.value = true;
  await nextTick(() => {
    if (addIntentModal.value) {
      addIntentModal.value.addNewIntent();
    }
  });
}

function editIntent(intent: IntentListItemViewModel) {
  intentToEdit.value = intent;
}

function deleteIntent(intent: IntentListItemViewModel) {
  intentToDelete.value = intent;
}

return (_ctx: any,_cache: any) => {
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_n_data_table = _resolveComponent("n-data-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createBlock(_component_n_loading_spinner, { key: 0 }))
      : (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("nav", _hoisted_7, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "level-left" }, null, -1)),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", _hoisted_9, [
                        _createVNode(_component_n_button, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (addIntent())),
                          variant: "primary"
                        }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createElementVNode("span", null, "Add Intent", -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createVNode(_component_n_data_table, {
                    columns: tableColumns,
                    onCellClicked: editIntent,
                    class: "table is-fullwidth intents",
                    items: sortedIntents.value
                  }, {
                    nodata: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "search",
                          class: "no-intents__icon",
                          size: "2x"
                        }),
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "no-intents__message" }, [
                          _createElementVNode("h1", null, "No intents found")
                        ], -1))
                      ])
                    ]),
                    actions: _withCtx(({ row }) => [
                      _createVNode(DropDownMenu, {
                        goLeft: true,
                        dropDownIcon: "dots"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (deleteIntent(row)),
                            class: "dropdown-item"
                          }, [
                            _createElementVNode("span", null, [
                              _createVNode(DeleteIcon)
                            ]),
                            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "action-label" }, "Delete", -1))
                          ], 8, _hoisted_11)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  }, 8, ["items"])
                ])
              ])
            ])
          ])
        ])),
    (showAddModal.value)
      ? (_openBlock(), _createBlock(AddIntentModal, {
          key: 2,
          ref_key: "addIntentModal",
          ref: addIntentModal,
          onCompleted: _cache[1] || (_cache[1] = ($event: any) => (showAddModal.value = false)),
          onClosed: _cache[2] || (_cache[2] = ($event: any) => (showAddModal.value = false))
        }, null, 512))
      : _createCommentVNode("", true),
    (showDeleteModal.value)
      ? (_openBlock(), _createBlock(DeleteIntentModal, {
          key: 3,
          intent: intentToDelete.value,
          onCancel: _cache[3] || (_cache[3] = ($event: any) => (intentToDelete.value = undefined)),
          onDeleted: _cache[4] || (_cache[4] = ($event: any) => (intentToDelete.value = undefined)),
          onFailedToDelete: _cache[5] || (_cache[5] = ($event: any) => (intentToDelete.value = undefined))
        }, null, 8, ["intent"]))
      : _createCommentVNode("", true),
    (showEditModal.value)
      ? (_openBlock(), _createBlock(EditIntentModal, {
          key: 4,
          "intent-id": intentToEdit.value.id,
          onClosed: _cache[6] || (_cache[6] = ($event: any) => (intentToEdit.value = undefined)),
          onCompleted: onEditCompleted,
          onFailedToLoad: _cache[7] || (_cache[7] = ($event: any) => (intentToEdit.value = undefined))
        }, null, 8, ["intent-id"]))
      : _createCommentVNode("", true)
  ]))
}
}

})